import * as React from 'react';
import { useSelected } from 'slate-react';
import styled from 'styled-components';

import { BaseBulletPointPluginProps } from '../BulletPointPlugin.types';
import { ListSwitcherPopOver } from '../components/ListSwitcherPopOver';
import { SharedListStyle } from './ListStyle';
import { useCheckListIsFirstChild } from './UnorderedListElement';

const Main = styled.ol`
  ${SharedListStyle};

  li {
    [data-slate-node='text'] {
      display: inline;
    }
  }
`;

interface OrderedListElementProps extends BaseBulletPointPluginProps {}

export const OrderedListElementEditable = (props: OrderedListElementProps) => {
  const { children, attributes, isReadOnly } = props;
  const ref = React.useRef();
  const isFirstChild = useCheckListIsFirstChild(ref);
  const selected = useSelected();

  return (
    <Main {...attributes} className="ordered-list-element">
      {children}
      <div ref={ref} />
      {!isReadOnly && isFirstChild && selected && <ListSwitcherPopOver />}
    </Main>
  );
};

export const OrderedListElementReadOnly = (props: OrderedListElementProps) => {
  const { children, attributes } = props;

  return (
    <ol {...attributes} className="ordered-list-element">
      {children}
    </ol>
  );
};
